import { PERSIST_TABLE, TEMP_TABLE, UnifiedFileSystem } from './unified.file.system';

const tempFs = new UnifiedFileSystem('temporary-storage', TEMP_TABLE);
const persistentFS = new UnifiedFileSystem('persistent-storage', PERSIST_TABLE);

export function getFileSystem(temporary?: boolean) {
  return temporary ? tempFs : persistentFS;
}
